import { render, staticRenderFns } from "./abstshebei.vue?vue&type=template&id=3a1ac184&scoped=true&"
import script from "./abstshebei.vue?vue&type=script&lang=js&"
export * from "./abstshebei.vue?vue&type=script&lang=js&"
import style0 from "./abstshebei.vue?vue&type=style&index=0&id=3a1ac184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1ac184",
  null
  
)

export default component.exports